import { calculateImageCellSize } from '@/app/gridGL/HTMLGrid/GridFileInput';
import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';
import { quadraticCore } from '@/app/web-workers/quadraticCore/quadraticCore';

const MAX_IMAGE_SIZE_MB = 10;

/**
 * Uploads an image file to a cell in the grid.
 * Reads the file, loads it to determine dimensions, and sets it as a cell image.
 */
export function uploadImageToCell(file: File, sheetId: string, column: number, row: number): void {
  if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
    gridSettings.addGlobalSnackbar?.(`Image must be smaller than ${MAX_IMAGE_SIZE_MB}MB`, { severity: 'error' });
    return;
  }

  const reader = new FileReader();
  reader.onerror = () => {
    gridSettings.addGlobalSnackbar?.('Failed to read image file', { severity: 'error' });
  };
  reader.onload = () => {
    const dataUrl = reader.result as string;
    const img = new Image();
    img.onerror = () => {
      gridSettings.addGlobalSnackbar?.('Failed to load image', { severity: 'error' });
    };
    img.onload = () => {
      const { width, height } = calculateImageCellSize(column, row, img.width, img.height, sheetId);
      quadraticCore.setCellImage(sheetId, column, row, dataUrl, false, width, height);
    };
    img.src = dataUrl;
  };
  reader.readAsDataURL(file);
}
